<template>
	<div id="page404" class="page-not-found main">
		<div class="info container">
			<h1>Finner du ikke frem?</h1>
			<Button class="color-link" type="pink" link :outlined="false">
				<router-link to="/">TIL FORSIDEN</router-link>
			</Button>
		</div>
	</div>
</template>

<script>
import Button from '@/components/elements/Button'

export default {
	name: 'PAGE-NOT-FOUND',
	components: {
		Button,
	},
	methods: {
		backToHome() {
			this.$router.push({ name: 'frontPage' })
		},
	},
	beforeCreate() {
		jQuery(document).ready(function ($) {
			$('html').addClass('is-404')
		})
	},
	destroyed() {
		jQuery(document).ready(function ($) {
			$('html').removeClass('is-404')
		})
	},
}
</script>

<style lang="scss">
@import './../assets/vars.scss';
@import './../assets/mixins.scss';
$color-bg: #fff;

html.is-404 {
	height: 100%;
	body {
		height: 100%;
		background-color: $color-bg;
	}
	#app {
		height: 100%;
		display: flex;
		flex-direction: column;
	}
}
#page404 {
	padding-top: 14%;
	padding-bottom: 150px;
	display: flex;
	flex: 1 0 auto;
	align-items: center;
	@include mquery($phone) {
		padding-top: 100px;
		padding-bottom: 100px;
		display: block;
	}
	.fill-button {
		margin: 25px auto;
	}
	.info {
		text-align: center;
		@include mquery($phone) {
			width: 100%;
			padding-top: 40px;
			padding-left: 0px;
		}
	}
}
</style>
